module.exports = __webpack_public_path__ + "img/Support-skill-106.77a93f85.png";